/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { BatchCreateImportJobRowsRequestToJSON, BatchUpdateImportJobRowsRequestToJSON, CreateImportJobRequestToJSON, CreateImportJobRowRequestToJSON, ImportCommitReportFromJSON, ImportFarseerFileRequestToJSON, ImportJobRepresentationFromJSON, ImportJobRowRepresentationFromJSON, UpdateImportJobRequestToJSON, UpdateImportJobRowRequestToJSON, } from '../models';
/**
 *
 */
var ImportJobsApi = /** @class */ (function (_super) {
    __extends(ImportJobsApi, _super);
    function ImportJobsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Batch create import job rows
     */
    ImportJobsApi.prototype.batchCreateImportJobRowsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling batchCreateImportJobRows.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/importJobRows/batch".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: BatchCreateImportJobRowsRequestToJSON(requestParameters.batchCreateImportJobRowsRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Batch create import job rows
     */
    ImportJobsApi.prototype.batchCreateImportJobRows = function (importJobId, batchCreateImportJobRowsRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.batchCreateImportJobRowsRaw({
                            importJobId: importJobId,
                            batchCreateImportJobRowsRequest: batchCreateImportJobRowsRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Batch update import job rows
     */
    ImportJobsApi.prototype.batchUpdateImportJobRowsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling batchUpdateImportJobRows.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/importJobRows/batch".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: BatchUpdateImportJobRowsRequestToJSON(requestParameters.batchUpdateImportJobRowsRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Batch update import job rows
     */
    ImportJobsApi.prototype.batchUpdateImportJobRows = function (importJobId, batchUpdateImportJobRowsRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.batchUpdateImportJobRowsRaw({
                            importJobId: importJobId,
                            batchUpdateImportJobRowsRequest: batchUpdateImportJobRowsRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Commit import job changes
     */
    ImportJobsApi.prototype.commitRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling commit.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/commit".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ImportCommitReportFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Commit import job changes
     */
    ImportJobsApi.prototype.commit = function (importJobId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commitRaw({ importJobId: importJobId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create import job
     */
    ImportJobsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createImportJobRequest === null ||
                            requestParameters.createImportJobRequest === undefined) {
                            throw new runtime.RequiredError('createImportJobRequest', 'Required parameter requestParameters.createImportJobRequest was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateImportJobRequestToJSON(requestParameters.createImportJobRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ImportJobRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create import job
     */
    ImportJobsApi.prototype.create = function (createImportJobRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createImportJobRequest: createImportJobRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create import job row
     */
    ImportJobsApi.prototype.createImportJobRowRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling createImportJobRow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/importJobRows".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateImportJobRowRequestToJSON(requestParameters.createImportJobRowRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create import job row
     */
    ImportJobsApi.prototype.createImportJobRow = function (importJobId, createImportJobRowRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createImportJobRowRaw({
                            importJobId: importJobId,
                            createImportJobRowRequest: createImportJobRowRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete import job row
     */
    ImportJobsApi.prototype.deleteImportJobRowRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling deleteImportJobRow.');
                        }
                        if (requestParameters.importJobRowId === null || requestParameters.importJobRowId === undefined) {
                            throw new runtime.RequiredError('importJobRowId', 'Required parameter requestParameters.importJobRowId was null or undefined when calling deleteImportJobRow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/importJobRows/{importJobRowId}"
                                    .replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId)))
                                    .replace("{".concat('importJobRowId', "}"), encodeURIComponent(String(requestParameters.importJobRowId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete import job row
     */
    ImportJobsApi.prototype.deleteImportJobRow = function (importJobId, importJobRowId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteImportJobRowRaw({ importJobId: importJobId, importJobRowId: importJobRowId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Detect dimensions in import data
     */
    ImportJobsApi.prototype.detectDimensionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling detectDimensions.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/detectDimensions".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Detect dimensions in import data
     */
    ImportJobsApi.prototype.detectDimensions = function (importJobId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.detectDimensionsRaw({ importJobId: importJobId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch import job by id
     */
    ImportJobsApi.prototype.getRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling get.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return ImportJobRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch import job by id
     */
    ImportJobsApi.prototype.get = function (importJobId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw({ importJobId: importJobId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch import job rows
     */
    ImportJobsApi.prototype.getImportJobRowsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling getImportJobRows.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/importJobRows".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(ImportJobRowRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Fetch import job rows
     */
    ImportJobsApi.prototype.getImportJobRows = function (importJobId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getImportJobRowsRaw({ importJobId: importJobId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Import Farseer file
     */
    ImportJobsApi.prototype.importFarseerFileRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importFarseerFileRequest === null ||
                            requestParameters.importFarseerFileRequest === undefined) {
                            throw new runtime.RequiredError('importFarseerFileRequest', 'Required parameter requestParameters.importFarseerFileRequest was null or undefined when calling importFarseerFile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/importFarseerFile",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: ImportFarseerFileRequestToJSON(requestParameters.importFarseerFileRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(ImportJobRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Import Farseer file
     */
    ImportJobsApi.prototype.importFarseerFile = function (importFarseerFileRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.importFarseerFileRaw({ importFarseerFileRequest: importFarseerFileRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all import jobs
     */
    ImportJobsApi.prototype.listRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.labels) {
                            queryParameters['labels'] = requestParameters.labels;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(ImportJobRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find all import jobs
     */
    ImportJobsApi.prototype.list = function (labels) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw({ labels: labels })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete import job
     */
    ImportJobsApi.prototype.removeRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling remove.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete import job
     */
    ImportJobsApi.prototype.remove = function (importJobId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeRaw({ importJobId: importJobId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Revert import job
     */
    ImportJobsApi.prototype.revertRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling revert.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/revert".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Revert import job
     */
    ImportJobsApi.prototype.revert = function (importJobId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.revertRaw({ importJobId: importJobId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update import job
     */
    ImportJobsApi.prototype.updateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling update.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}".replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateImportJobRequestToJSON(requestParameters.updateImportJobRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update import job
     */
    ImportJobsApi.prototype.update = function (importJobId, updateImportJobRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRaw({ importJobId: importJobId, updateImportJobRequest: updateImportJobRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update import job row
     */
    ImportJobsApi.prototype.updateImportJobRowRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importJobId === null || requestParameters.importJobId === undefined) {
                            throw new runtime.RequiredError('importJobId', 'Required parameter requestParameters.importJobId was null or undefined when calling updateImportJobRow.');
                        }
                        if (requestParameters.importJobRowId === null || requestParameters.importJobRowId === undefined) {
                            throw new runtime.RequiredError('importJobRowId', 'Required parameter requestParameters.importJobRowId was null or undefined when calling updateImportJobRow.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/importJobs/{importJobId}/importJobRows/{importJobRowId}"
                                    .replace("{".concat('importJobId', "}"), encodeURIComponent(String(requestParameters.importJobId)))
                                    .replace("{".concat('importJobRowId', "}"), encodeURIComponent(String(requestParameters.importJobRowId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateImportJobRowRequestToJSON(requestParameters.updateImportJobRowRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update import job row
     */
    ImportJobsApi.prototype.updateImportJobRow = function (importJobId, importJobRowId, updateImportJobRowRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateImportJobRowRaw({
                            importJobId: importJobId,
                            importJobRowId: importJobRowId,
                            updateImportJobRowRequest: updateImportJobRowRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ImportJobsApi;
}(runtime.BaseAPI));
export { ImportJobsApi };
